<section class="global-search-dialog">
  <header class="dialog-header">
    <div>
      <div class="eyebrow"><span class="pi pi-search"></span> Project search</div>
      <h2>Search results</h2>
      <p>{{ resultCount }} result{{ resultCount !== 1 ? 's' : '' }} found in the current project</p>
    </div>
    <button pButton icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" (click)="close()" aria-label="Close"></button>
  </header>

  <div class="dialog-content">
    @if (resultCount === 0) {
      <div class="empty-state"><span class="pi pi-search"></span><strong>No results found</strong><span>Try a tag number, tag name, checksheet number, punch description, SAP ID, or user name.</span></div>
    } @else {
      <p-tabs value="tags">
        <p-tablist>
          <p-tab value="tags">Tags <span class="count-badge">{{ data.tags.length }}</span></p-tab>
          <p-tab value="checksheets">Checksheets <span class="count-badge">{{ data.checksheets.length }}</span></p-tab>
          <p-tab value="punches">Punches <span class="count-badge">{{ data.punches.length }}</span></p-tab>
          <p-tab value="users">Users <span class="count-badge">{{ data.users.length }}</span></p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="tags">
            <p-table [value]="data.tags" styleClass="result-table" [scrollable]="true" scrollHeight="48vh">
              <ng-template #header><tr><th>Tag number</th><th>Name</th><th>CP</th><th>MC package</th><th>Checksheet</th></tr></ng-template>
              <ng-template #body let-result><tr>
                <td><strong>{{ result.tagNumber }}</strong></td><td>{{ result.secondaryText || '—' }}</td>
                <td><button class="link-button" type="button" (click)="openCp(result)" [disabled]="!result.cpId">{{ result.cpNumber || '—' }}</button></td>
                <td><button class="link-button" type="button" (click)="openMcPackage(result)" [disabled]="!result.mcpId">{{ result.mcNumber || '—' }}</button></td>
                <td><button class="link-button" type="button" (click)="openChecksheet(result)" [disabled]="!result.csaId || !result.cpId">{{ result.csNumber || 'No checksheet assignment' }}</button></td>
              </tr></ng-template>
              <ng-template #emptymessage><tr><td colspan="5">No matching tags.</td></tr></ng-template>
            </p-table>
          </p-tabpanel>
          <p-tabpanel value="checksheets">
            <p-table [value]="data.checksheets" styleClass="result-table" [scrollable]="true" scrollHeight="48vh">
              <ng-template #header><tr><th>Checksheet</th><th>Tag</th><th>CP</th><th>MC package</th></tr></ng-template>
              <ng-template #body let-result><tr>
                <td><button class="link-button primary-link" type="button" (click)="openChecksheet(result)">{{ result.csNumber }}</button></td><td>{{ result.tagNumber || '—' }}</td>
                <td><button class="link-button" type="button" (click)="openCp(result)" [disabled]="!result.cpId">{{ result.cpNumber || '—' }}</button></td>
                <td><button class="link-button" type="button" (click)="openMcPackage(result)" [disabled]="!result.mcpId">{{ result.mcNumber || '—' }}</button></td>
              </tr></ng-template>
              <ng-template #emptymessage><tr><td colspan="4">No matching checksheets.</td></tr></ng-template>
            </p-table>
          </p-tabpanel>
          <p-tabpanel value="punches">
            <p-table [value]="data.punches" styleClass="result-table" [scrollable]="true" scrollHeight="48vh">
              <ng-template #header><tr><th>Description</th><th>Tag</th><th>Checksheet</th><th>CP</th><th>MC package</th><th class="action-column">Punch</th></tr></ng-template>
              <ng-template #body let-result><tr>
                <td class="description-cell">{{ result.primaryText }}</td><td>{{ result.tagNumber || '—' }}</td><td><button class="link-button primary-link" type="button" (click)="openChecksheet(result)">{{ result.csNumber || '—' }}</button></td>
                <td><button class="link-button" type="button" (click)="openCp(result)" [disabled]="!result.cpId">{{ result.cpNumber || '—' }}</button></td>
                <td><button class="link-button" type="button" (click)="openMcPackage(result)" [disabled]="!result.mcpId">{{ result.mcNumber || '—' }}</button></td>
                <td class="action-column"><button pButton icon="pi pi-eye" [rounded]="true" [text]="true" severity="secondary" size="small" (click)="openPunch(result)" [disabled]="!result.punchId" aria-label="Open punch" title="Open punch"></button></td>
              </tr></ng-template>
              <ng-template #emptymessage><tr><td colspan="6">No matching punches.</td></tr></ng-template>
            </p-table>
          </p-tabpanel>
          <p-tabpanel value="users">
            <div class="user-layout">
              <p-table [value]="data.users" styleClass="result-table" [scrollable]="true" scrollHeight="32vh">
                <ng-template #header><tr><th>User</th><th>SAP ID</th><th class="action-column"></th></tr></ng-template>
                <ng-template #body let-user><tr [class.selected-row]="selectedUser?.userId === user.userId">
                  <td><strong>{{ user.primaryText }}</strong></td><td><p-tag [value]="user.sapId || 'No SAP ID'" severity="secondary"></p-tag></td>
                  <td class="action-column"><button pButton label="View signings" icon="pi pi-history" [text]="true" size="small" (click)="showSigningActions(user)"></button></td>
                </tr></ng-template>
                <ng-template #emptymessage><tr><td colspan="3">No users with signing actions match this search.</td></tr></ng-template>
              </p-table>
              @if (selectedUser) {
                <section class="signing-panel">
                  <div class="panel-title"><div><span class="eyebrow">Signing history</span><h3>{{ selectedUser.primaryText }}</h3></div><p-tag value="Latest 50" severity="info"></p-tag></div>
                  @if (signingActions === null) { <div class="loading-state">Loading signing actions…</div> }
                  @else if (signingActions.length === 0) { <div class="loading-state">No signing actions found in this project.</div> }
                  @else {
                    <p-table [value]="signingActions" styleClass="result-table signing-table" [scrollable]="true" scrollHeight="28vh">
                      <ng-template #header><tr><th>Signed at</th><th>Tag</th><th>Checksheet</th><th class="action-column"></th></tr></ng-template>
                      <ng-template #body let-action><tr><td>{{ action.signedAt | date: 'medium' }}</td><td>{{ action.tagNumber }}</td><td>{{ action.csNumber || '—' }}</td><td class="action-column"><button pButton label="Open" icon="pi pi-arrow-up-right" [text]="true" size="small" (click)="openAction(action)"></button></td></tr></ng-template>
                    </p-table>
                  }
                </section>
              }
            </div>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    }
  </div>

  <footer class="dialog-footer"><button pButton label="Close" icon="pi pi-times" severity="secondary" [outlined]="true" (click)="close()"></button></footer>
</section>


